import Joi from 'joi';

const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,7}$/m;
const phone = Joi.string().regex(phoneRegex)
	.options({
		language: {
			string: {
				regex: {
					base: 'must be a valid phone number'
				}
			}
		}
	});

const user = {};

user.update = {
	fname: Joi.string().min(2).max(24),
	lname: Joi.string().min(2).max(24),
	avatar: Joi.string().min(2).max(24)
};

user.credentials = {
	user_id: Joi.number().required(),
	title: Joi.string().min(2).max(24).required(),
	file: Joi.string().required()
};

user.bank = {
	bank_name: Joi.string().min(3),
	account_name: Joi.string().min(3),
	account_number: Joi.string().regex(/^[0-9]{9}$/).options({
		language: {
			string: {
				regex: {
					base: 'must be at least 9 numbers and must be numeric'
				}
			}
		}
	}),
	bvn: Joi.string().regex(/^[0-9]{11}$/).options({
		language: {
			string: {
				regex: {
					base: 'must be at least 11 numbers and must be numeric'
				}
			}
		}
	})
};

export default user;
